const FIELD_GUIDANCE_LABELS = {
  summary: {
    empty: 'Add a Job Summary',
    filled: 'Job Summary Added',
    tooltip_long: 'A clear job summary helps ensure this role is evaluated, leveled, '
      + 'and compensated consistently across the organization.',
    initiallyOpen: true,
  },
  responsibilities: {
    empty: 'Add Primary Responsibilities',
    filled: 'Primary Responsibilities Added',
  },
  skills: {
    empty: 'Add Required Skills',
    filled: 'Required Skills Added',
  },
  experience: {
    empty: 'Add Required Work Experience',
    filled: 'Required Work Experience Added',
  },
  competencies: {
    empty: 'Add Competencies',
    filled: 'Competencies Added',
  },
  education: {
    empty: 'Add Education Requirements',
    filled: 'Education Requirements Added',
  },
  certifications: {
    empty: 'Add Certification Requirements',
    filled: 'Certification Requirements Added',
  },
};

export const buildFieldGuidanceMessage = (field, isEmpty) => {
  const generatorType = field.content_generator_type;
  const labels = FIELD_GUIDANCE_LABELS[generatorType] ?? null;

  // Field has content so show a green "added" kudo in the sidebar.
  if (!isEmpty) {
    return {
      severity_class: 'green-solid',
      action: 'custom',
      is_nudge: false,
      tooltip_short: labels?.filled ?? `${field.label} Added`,
      suggestions: [],
    };
  }

  // Field is empty so show guidance. Summary goes under Setup Issues
  let severityClass = 'blue-underline';

  if (generatorType === 'summary') {
    severityClass = 'red-underline';
  }

  const message = {
    severity_class: severityClass,
    action: generatorType ? `custom_${generatorType}` : 'custom',
    is_nudge: false,
    tooltip_short: labels?.empty ?? `Add ${field.label}`,
    suggestions: [],
  };

  if (labels?.tooltip_long) {
    message.tooltip_long = labels.tooltip_long;
  }

  if (labels?.initiallyOpen) {
    message.initiallyOpen = true;
  }

  return message;
};

export const buildRequiredFieldGuidanceMessages = (fields, getFieldHtml, isEmptyHtml) => {
  const messages = {};

  fields
    .filter((field) => field.is_required)
    .forEach((field) => {
      const fieldKey = field.id || field.type;
      const isEmpty = isEmptyHtml(getFieldHtml(fieldKey));

      messages[`guidance_field_${fieldKey}`] = buildFieldGuidanceMessage(field, isEmpty);
    });

  return messages;
};
